import * as utils from '../utils.js'
const _shopgirls = {
/*
  2: [
       {
         id: 1,
         shopid: 2,
         name: 'なる',
         age: 19,
         height: 160,
         weight: 60,
         b: 80,
         w: 80,
         h: 80,
         cup: 'C',
         url: 'http://www.h-school.jp/profile.html?uid=581',
         avator_url: 'http://www.h-school.jp/data/girl/581_1.jpg?date=1463972214'
       }
     ]
*/
}


export default (state = _shopgirls, action) => {
  switch (action.type) {
    case 'SET_GIRLS':
      return Object.assign({}, state, {[action.shop.id]:action.girls})

    case 'SET_GIRL_LOADING':
      return Object.assign({}, state, {[action.shop.id]:null})

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/girls.js